import React , {useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table, Badge } from 'react-bootstrap'

import {loadLectures, loadLectureDetail} from '../actions/lectureActions'

import {loadCourseDetail} from '../actions/courseActions'

import LectureVideo from '../components/notecards/items/LectureVideo'

//import {eventTracker} from '../actions/trackerActions'


import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

import Meta from '../components/Meta'

export const CourseDetailScreen = ({match, history}) => {

    
    const dispatch = useDispatch()

   

    //const course_url = match.params.course_url

    const {course_url}  = useParams();


    // const lecturelist = useSelector(state => state.lecturelist)
    // const {lectures} = lecturelist

    const courseDetail = useSelector(state => state.courseDetail)
    const {courseDet} = courseDetail

    const lectureDetail = useSelector(state => state.lectureDetail)
    const {lectureDet} = lectureDetail



    const [sectionType, setSectionType] = useState("basics") 
    const [newModel, setNewModel] = useState("") 

    const [selectedLecture, setSelectedLecture] = useState("")


    const [viewMode, setViewMode] = useState("lectures")
    const toggleViewMode = (mode_in) => {
        setViewMode(mode_in)
    }


    const selectPageRequest = (module_in) => {
        setSectionType(module_in)
        //dispatch(loadLecturesAdmin(module_in))
    }

    const navigateToPage = (pageURL) => {
        history.push(`/lectures/${pageURL}`)
    }

    const selectLectureVideo = (lecture_id) => {
        setSelectedLecture(lecture_id)
        dispatch(loadLectureDetail(lecture_id))

        var deviceType = isMobile ? 'mobilebrowser': 'webbrowser'
        
        //dispatch(eventTracker('Lecture', 'lecture', deviceType, {lecture_id:lecture_id}))

    }

    
    

  

    useEffect(() => {
        
        dispatch(loadCourseDetail(course_url))

        //dispatch(loadLectures())

       // var deviceType = isMobile ? 'mobilebrowser': 'webbrowser'
        
        //dispatch(eventTracker('Course Page', 'page', deviceType, {url:course_url}))

    }, [])





    return(
        <div style={{ marginTop: '0px', fontFamily: 'Inter, Roboto, "Open Sans", Arial, sans-serif', background: '#f8f9fa', minHeight: '100vh' }}>
            <Meta
                title={'AI Lectures and Classes'}
                description={'Find a comprehensive collection of lectures taught on deep Learning, neural networks, convolutional networks, transformers, large language models. Find lectures on the basic prerequisite topics like matrices, probability, differentiation. Also find lectures on Python programming and Deep Learning libraries like Pytorch and Tensorflow.'}
            />

            {/* Course Header */}
            <Container style={{ maxWidth: 900, margin: '0 auto', marginTop: 32, marginBottom: 32 }}>
                <Card style={{ borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', border: 'none', padding: 0 }}>
                    <Card.Header style={{ background: '#fff', borderTopLeftRadius: 18, borderTopRightRadius: 18 }}>
                        {courseDet && (
                            <>
                                <p className="h3" style={{ fontWeight: 700, color: '#0C0854', marginBottom: 8 }}>Course: {courseDet.title}</p>
                                {courseDet.instructors && (
                                    <p style={{ marginBottom: 8 }}><span className="h5" style={{ color: '#6b0752' }}>Instructor: </span><span className="h5">{courseDet.instructors.toString()}</span></p>
                                )}
                                <p style={{ marginBottom: 0 }}><span style={{ color: '#888' }}>Course description:</span> <span className="h5">{courseDet.description}</span></p>
                            </>
                        )}
                    </Card.Header>
                </Card>
            </Container>

            {/* Main Content: Sidebar + Video */}
            <Container fluid style={{ maxWidth: 1300 }}>
                {isMobile ? (
                    <>
                        {/* Mobile: Lectures list, then video below */}
                        <div style={{ marginBottom: 24 }}>
                            <h4 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 16 }}>Lectures</h4>
                            <ListGroup style={{ border: 'none' }}>
                                {courseDet && courseDet.lectures && courseDet.lectures.map((lec, index) => (
                                    <ListGroup.Item key={lec.url} style={{ padding: 0, border: 'none', marginBottom: 16, background: 'none' }}>
                                        <Card
                                            style={{
                                                padding: '14px',
                                                borderRadius: '16px',
                                                boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                                                border: 'none',
                                                cursor: 'pointer',
                                                background: selectedLecture === lec.url ? '#e6e6fa' : '#fff',
                                                transition: 'background 0.2s',
                                            }}
                                            onClick={() => selectLectureVideo(lec.url)}
                                        >
                                            <Card.Header style={{ background: 'none', border: 'none', padding: 0 }}>
                                                <span className="h5" style={{ fontWeight: 600, color: '#0C0854' }}>{lec.title}</span>
                                                {lec.lectureisPosted === false && (
                                                    <Badge style={{ backgroundColor: '#2CCCD6', color: 'white', padding: '6px 12px', borderRadius: '8px', fontSize: 14, marginLeft: 8 }}>
                                                        Coming Soon
                                                    </Badge>
                                                )}
                                            </Card.Header>
                                        </Card>
                                        {lectureDet && lectureDet.url === lec.url && lectureDet.lectureVideo && (
                                            <Card.Body style={{ background: '#f8f9fa', borderRadius: '0 0 16px 16px', marginTop: 8 }}>
                                                <div style={{ marginBottom: 12 }}>{lectureDet.description}</div>
                                                <LectureVideo video_in={lectureDet.lectureVideo} mode_in="view" />
                                            </Card.Body>
                                        )}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </div>
                    </>
                ) : (
                    <Row style={{ minHeight: '60vh', marginTop: 16 }}>
                        {/* Sidebar */}
                        <Col md={4} lg={3} style={{ maxWidth: 340, minWidth: 240, background: 'none', paddingRight: 0 }}>
                            <div style={{ position: 'sticky', top: 32 }}>
                                <h4 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 16 }}>Lectures</h4>
                                <ListGroup style={{ border: 'none' }}>
                                    {courseDet && courseDet.lectures && courseDet.lectures.map((lec, index) => (
                                        <ListGroup.Item key={lec.url} style={{ padding: 0, border: 'none', marginBottom: 16, background: 'none' }}>
                                            <Card
                                                style={{
                                                    padding: '14px',
                                                    borderRadius: '16px',
                                                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    background: selectedLecture === lec.url ? '#e6e6fa' : '#fff',
                                                    transition: 'background 0.2s',
                                                }}
                                                onClick={() => selectLectureVideo(lec.url)}
                                            >
                                                <Card.Header style={{ background: 'none', border: 'none', padding: 0 }}>
                                                    <span className="h5" style={{ fontWeight: 600, color: '#0C0854' }}>{lec.title}</span>
                                                    {lec.lectureisPosted === false && (
                                                        <Badge style={{ backgroundColor: '#2CCCD6', color: 'white', padding: '6px 12px', borderRadius: '8px', fontSize: 14, marginLeft: 8 }}>
                                                            Coming Soon
                                                        </Badge>
                                                    )}
                                                </Card.Header>
                                            </Card>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </div>
                        </Col>
                        {/* Main Video Area */}
                        <Col md={8} lg={9} style={{ paddingLeft: 24 }}>
                            {lectureDet && lectureDet.lectureVideo ? (
                                <Card style={{ borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', border: 'none', padding: 0 }}>
                                    <Card.Body style={{ background: '#f8f9fa', borderRadius: 18 }}>
                                        <div style={{ marginBottom: 12 }}>{lectureDet.description}</div>
                                        <LectureVideo video_in={lectureDet.lectureVideo} mode_in="view" />
                                    </Card.Body>
                                </Card>
                            ) : (
                                <div style={{ color: '#888', textAlign: 'center', marginTop: 40 }}>Select a lecture to view its video and details.</div>
                            )}
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    )


}

export default CourseDetailScreen


